import {
  landerBelowTheFoldSchema,
  useAppFeaturesCarouselAssetsQuery,
  useExpertReviewsAdditionalQuery,
  useExpertReviewsAssetQuery,
  useQuoteWizardQuery
} from '@ecomm/lander'
import { graphql, useStaticQuery } from 'gatsby'

const homepageQuery = graphql`
  query HomePageQuery {
    videoButtonAsset: contentfulAsset(contentful_id: { eq: "485NQEr4JUie3FE2IIlZ7B" }) {
      gatsbyImageData(placeholder: BLURRED)
      description
      title
    }
    contentfulAffirmBanner(contentful_id: { eq: "4VmV1UBXepTJFhRn8xKvni" }) {
      ...homeLandingAffirmBanner
    }
    quoteWizardAsset: contentfulAsset(contentful_id: { eq: "4mI9KaGvxh51fi1GYOSaVr" }) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      description
    }
    quoteWizardAssetOdmon: contentfulAsset(contentful_id: { eq: "69DPXF1HEn2ut0vVVWFSUK" }) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      description
    }
    cameraBannerAsset: contentfulAsset(contentful_id: { eq: "5mbs4LEkQgjIZpoFklL2ur" }) {
      gatsbyImageData(placeholder: BLURRED)
    }
    appFeaturesCarouselAssets: allContentfulAsset(
      filter: {
        contentful_id: {
          in: ["6rmX3DElVdPZn4Hw3JNqV9", "50wlqz44dQwAzOoxzmPO90", "4ju8RHivPNhZIeWF0WJ75X", "38iheGuzSVg8kPQ1aokAnw", "ZYB8WxMtOe454lse5FG2D", "6LT6dvk157aAfFdKyeG2Kf", "4WmsMErxVXBFHEjlFnRcD1", "77eZKHHyg4KdFR2T2WhH90", "4Z794ao9hfY826K8Tt4FXz"]
        }
      }
    ) {
      nodes {
        contentful_id
        id
        title
        description
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    expertReviewsAssets: allContentfulAsset(
      filter: {
        contentful_id: {
          in: ["6uVhRdfLw8y6L3x78SiCuM", "5qECjj8vYgV5ThjxYhWtaw", "5X5OsfxAW6Fc2Zj3HZDlHC", "7eH4KhA049wM5ZTOOmWyWd", "3aPO8RfSjwoD7HLMeS8pQE"]
        }
      }
    ) {
      nodes {
        contentful_id
        gatsbyImageData(width: 320)
        description
      }
    }
    expertReviewsAdditionalAssets: allContentfulAsset(filter: { contentful_id: { in: ["2zLbCUSDMAqzV7LqBPgxzE", "3Yk2CSFz84KprPq2t0oyU8"] } }) {
      nodes {
        contentful_id
        gatsbyImageData(width: 320)
        description
      }
    }
    guaranteeAsset: contentfulAsset(contentful_id: { eq: "5FRJNkZAaZL4mHk6vuMNVb" }) {
      gatsbyImageData(placeholder: BLURRED)
      description
    }
    guaranteeCopy: contentfulJson(contentful_id: { eq: "5bXaWtcoGF04HVmWb5Kuoe" }) {
      ...json
    }
    confidenceBar: contentfulJson(contentful_id: { eq: "5ynnx5XFY9LYRUyZEkN98K" }) {
      ...json
    }
    appWidget: contentfulJson(contentful_id: { eq: "5cJhxXLT1ybrC7lgAQItHU" }) {
      ...json
    }
    expertReviews: contentfulJson(contentful_id: { eq: "2143Uo0jib8jsfRyWv2DDQ" }) {
      ...json
    }
    expertReviewsAdditional: contentfulJson(contentful_id: { eq: "6IemG5492tUiqRu7HXa0B4" }) {
      ...json
    }
    expertSectionAsset: contentfulAsset(contentful_id: { eq: "4l8DenaxSNBl1LH3mmDLMv" }) {
      gatsbyImageData(placeholder: BLURRED)
    }
    videoBanner: contentfulJson(contentful_id: { eq: "2MYM4NXbeu10yXiO50b5VD" }) {
      ...json
    }
    videoBannerExperiment: contentfulJson(contentful_id: { eq: "6HFtBcxWkeEu0kq0gjeXWP" }) {
      ...json
    }
    hideVideoAndAffirmBannerExperiment: contentfulNinetailedFeatureFlag(contentful_id: { eq: "2RzdpsTO6FqOdqspVlgM2G" }) {
      ...homeLandingFeatureFlagBase
      nt_experiences {
        ...homeLandingFeatureFlagExperience
      }
    }
    alarmMoments: contentfulAlarmMoments(contentful_id: { eq: "5CZQz1gM66nNlwBekDnig2" }) {
      ...homeLandingAlarmMoments
    }
  }
`

const useHomepageQuery = () => {
  const quoteWizard = useQuoteWizardQuery('3GT1zG3PE5djEurbN7NQmm')
  const expertReviewsAssets = useExpertReviewsAssetQuery([
    '6uVhRdfLw8y6L3x78SiCuM',
    '5qECjj8vYgV5ThjxYhWtaw',
    '5X5OsfxAW6Fc2Zj3HZDlHC',
    '7eH4KhA049wM5ZTOOmWyWd',
    '3aPO8RfSjwoD7HLMeS8pQE'
  ])
  const expertReviewsAdditionalAssets = useExpertReviewsAssetQuery([
    '2zLbCUSDMAqzV7LqBPgxzE',
    '3Yk2CSFz84KprPq2t0oyU8'
  ])

  const expertReviewsAdditional = useExpertReviewsAdditionalQuery()

  const appFeaturesCarouselAssets = useAppFeaturesCarouselAssetsQuery([
    '6rmX3DElVdPZn4Hw3JNqV9',
    '4ju8RHivPNhZIeWF0WJ75X',
    '50wlqz44dQwAzOoxzmPO90',
    '38iheGuzSVg8kPQ1aokAnw',
    'ZYB8WxMtOe454lse5FG2D',
    '6LT6dvk157aAfFdKyeG2Kf',
    '4WmsMErxVXBFHEjlFnRcD1',
    '77eZKHHyg4KdFR2T2WhH90',
    '4Z794ao9hfY826K8Tt4FXz'
  ])

  const staticData = useStaticQuery(homepageQuery) || {}

  return landerBelowTheFoldSchema.parse({
    ...staticData,
    expertReviewsAssets,
    expertReviewsAdditionalAssets,
    expertReviewsAdditional,
    appFeaturesCarouselAssets,
    quoteWizard
  })
}

export { useHomepageQuery }
